import { motion } from "framer-motion";

const SPONSOR_IMG =
  "https://customer-assets.emergentagent.com/job_adult-baseball-hub/artifacts/4yfknr1r_sponsorprotilt.jpg";

export const Sponsors = () => {
  return (
    <section id="sponsors" data-testid="sponsors-section" className="relative py-24 lg:py-32 bg-[#050505] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-[#F4A261] text-xs font-bold uppercase tracking-[0.3em]">Proud Sponsors</span>
          <h2 className="text-4xl sm:text-5xl uppercase tracking-tighter mt-4 leading-[0.95]">
            Backed By The Community
          </h2>
          <p className="mt-6 text-[#C7CDD4] text-lg font-medium leading-relaxed">
            Local businesses keep this league on the field. A huge thank you to{" "}
            <span className="text-white font-bold">ProTilt Hauling &amp; Rentals</span> — our official sponsor
            supporting adult baseball across the Tri-Cities and surrounding communities.
          </p>
          <a
            href="#signup"
            data-testid="become-sponsor-cta"
            className="inline-block mt-8 font-heading uppercase tracking-wide bg-[#FF3B30] text-white hover:bg-[#FF6B63] transition-colors px-8 py-4"
          >
            Become A Sponsor
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="border border-white/10 overflow-hidden"
        >
          <img src={SPONSOR_IMG} alt="ProTilt Hauling & Rentals — Official WABL Sponsor" className="w-full h-full object-cover" />
        </motion.div>
      </div>
    </section>
  );
};
